
import { ViewPreciosPorRol } from "../../components";
import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { useCarritoClienteStore } from "../../../stores";
import { eliminarItemCarrito } from "../../../services";
import { useQueryClient } from "@tanstack/react-query";

const baseUrl = process.env.REACT_APP_API_URL;




export const TablaDeCarritoEnModal = ({ data, cliente=false }) => {


    const queryClient = useQueryClient();
    const { eliminarItem } = useCarritoClienteStore();
    

    const handleDelete = async(id) => {
        if( cliente ){
            eliminarItem(id)
            return;
        }
        const resp = await eliminarItemCarrito(id);
        if( resp ){ queryClient.invalidateQueries({ queryKey: ['carritoxuser'] }); }
    }

    

    return (
        <>
        {(!data || data.length === 0) 
        ?   <Typography variant="h4" sx={{color:'white', textAlign:'center'}}>No hay productos en el carrito</Typography>

        :   <TableContainer sx={{ width:'100%', border:'none', marginBottom:3 }}>
                <Table sx={{ width:'100%', border:'none' }}>
                    <TableBody>
                        {data.map((c) => (
                        <TableRow key={c.id} sx={{ borderBottom:'1px solid gray' }}>
                            {/* Imagen del Producto */}
                            <TableCell sx={{width:100, border:'none'}}>
                                <Box sx={{ width:80, height:80, borderRadius:2, overflow:'hidden', boxShadow:'0 4px 12px rgba(0,0,0,0.1)'}}>
                                    <img src={`${baseUrl}/uploads/productos/${c.producto?.img}`} 
                                        alt={c.producto?.nombre}
                                        style={{ width:'100%', height:'100%', objectFit:'cover'}}
                                    />
                                </Box>
                            </TableCell>
            
                            {/* Nombre y Cantidad */}
                            <TableCell sx={{display:'flex', flexDirection:'column', width:'auto', alignItems:'center' }}>
                                <Typography variant="span" sx={{color:'white', mb:0.5, fontSize:13 }}>
                                    {c.producto?.nombre}
                                </Typography>
                                <TextField type="number" value={c.cantidad} name="cantidad" sx={{ width:80 }} size="small"/>
                            </TableCell>
            
                            {/* Precios */}
                            <TableCell sx={{border:'none', width:90 }}>
                                <ViewPreciosPorRol formCarrito={c} mostrar={false} />
                            </TableCell>
            

                            <TableCell align="right" sx={{ border: 'none' }}>
                                <IconButton size="small" onClick={() => handleDelete(c.id)}
                                    sx={{ color:'error.main', '&:hover': {bgcolor: 'rgba(244, 67, 54, 0.08)'}}}
                                >
                                    <Delete fontSize="small" />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        }
        </>
    )
}
